var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51525_4548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.99992C14.6673 11.6818 11.6825 14.6666 8.00065 14.6666M14.6673 7.99992C14.6673 4.31802 11.6825 1.33325 8.00065 1.33325M14.6673 7.99992C14.6673 6.89535 11.6825 5.99992 8.00065 5.99992C4.31875 5.99992 1.33398 6.89535 1.33398 7.99992M14.6673 7.99992C14.6673 9.10449 11.6825 9.99992 8.00065 9.99992C4.31875 9.99992 1.33398 9.10449 1.33398 7.99992M8.00065 14.6666C4.31875 14.6666 1.33398 11.6818 1.33398 7.99992M8.00065 14.6666C9.47341 14.6666 10.6673 11.6818 10.6673 7.99992C10.6673 4.31802 9.47341 1.33325 8.00065 1.33325M8.00065 14.6666C6.52789 14.6666 5.33398 11.6818 5.33398 7.99992C5.33398 4.31802 6.52789 1.33325 8.00065 1.33325M1.33398 7.99992C1.33398 4.31802 4.31875 1.33325 8.00065 1.33325",
    stroke: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51525_4548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpIcon);
export default __webpack_public_path__ + "static/media/ip-icon.d84c1b5e17cd49c4a2c3fd4a5805486b.svg";
export { ForwardRef as ReactComponent };